// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"19":"d8432839","82":"8b520a26","521":"98e1af8e","635":"beecc210","726":"14348ced"}[chunkId] + ".js";
};